export default {
  linkedIn: '领英登录',

  //
  linkedinLogin: '领英登录',
}
